import { PhoneFilled } from "@ant-design/icons";
import { Modal, Button, message } from "antd";
import axios from "axios";
import "./ContactModal.scss";
import { useSelector } from "react-redux";

const ContactsModal = ({ open, setOpen, data }) => {
  const {token} = useSelector(state=>state.auth);
  
  const phoneNumbers = Object.keys(data || {})
    .filter((key) => key.startsWith("phone_number_") && data[key])
    .map((key) => data[key]);

  if (data?.cust_mobile_no && !phoneNumbers.includes(data.cust_mobile_no)) {
    phoneNumbers.push(data.cust_mobile_no);
  }

  const handleCall = async (num) => {
    try {
      message.loading({ content: `Initiating call to ${num}...`, key: "call" });

      const response = await axios.post(
        `/telecaller/click-to-call/?to_number=${num}`,{},
        {
          headers: {
            Authorization: `Bearer ${token}`,  // ✅ attach token
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        message.success({
          content: `Call triggered successfully to ${num}`,
          key: "call",
          duration: 2,
        });
        setOpen(false);
      } else {
        message.error({
          content: `Unable to trigger call. Please try again.`,
          key: "call",
          duration: 2,
        });
        setOpen(false);
      }
    } catch (error) {
      console.error("Click-to-call error:", error);
      message.error({
        content: "Failed to trigger call. Check connection or permissions.",
        key: "call",
        duration: 2,
      });
      setOpen(false);
    }
  };

  return (
    <Modal
      footer={false}
      title="Select and Call"
      open={open}
      onCancel={() => setOpen(false)}
      className="contacts-modal"
    >
      <div className="contact-list">
        {phoneNumbers?.length > 0 ? (
          phoneNumbers.map((num, index) => (
            <div key={index} className="contact-item">
              <span className="contact-number">{num}</span>
              <Button
                className="call-button"
                type="primary"
                shape="circle"
                onClick={() => handleCall(num)}
              >
                <PhoneFilled />
              </Button>
            </div>
          ))
        ) : (
          <p className="no-data">No phone numbers available</p>
        )}
      </div>
    </Modal>
  );
};

export default ContactsModal;
